import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header/Header';
import Payments from '../components/Payments';


const PaymentsPage = () => {
    return (
        <>
            <Header />
            <Payments/>
            <Footer />
        </>
    )
}

export default PaymentsPage;